var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LawyerInputs',{attrs:{"id":_vm.id,"name":_vm.name},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }